import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BrandButton } from "../ui/BrandButton";

export function LogoutButton({
  className = "",
  children = "Cerrar sesión",
  variant = "outline",
  radius = "full",
  size = "lg",
  motion = "subtle",
  ...props
}) {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate("/", { replace: true, preventScrollReset: true });
  };

  return (
    <BrandButton
      type="button"
      onClick={handleLogout}
      variant={variant}
      radius={radius}
      size={size}
      motion={motion}
      className={className}
    >
      {children}
    </BrandButton>
  );
}
